import { useLogout } from "@/api/mutations/auth";
import { useMe } from "@/api/queries/auth";
import { queryKeys } from "@/api/queryKeys";
import { ACCESS_TOKEN } from "@/constants/auth";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const ProtectedRoute = () => {
  const { data: me, isLoading } = useMe();
  const { mutateAsync: logoutAsync } = useLogout();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await logoutAsync();
      localStorage.removeItem(ACCESS_TOKEN);
    } catch {
      // Do nothing
    } finally {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.me] });
      toast.warning(
        "Your account has been disabled. Please contact your administrator for assistance.",
      );
      navigate("/login");
    }
  };

  useEffect(() => {
    if (me?.data) {
      if (!me.data.active) {
        logout();
      }
    }
  }, [me]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
